import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'app-process-media-list',
  templateUrl: './process-media-list.component.html',
  styleUrls: ['./process-media-list.component.scss']
})
export class ProcessMediaListComponent implements OnChanges {
  @Input() mediaFiles: any[] = [];
  @Output() previewImage = new EventEmitter<{file: any, index: number}>();
  @Output() downloadFile = new EventEmitter<any>();

  filteredMediaFiles: any[] = [];
  selectedMediaFilter: 'all' | 'images' | 'files' = 'all';

  ngOnChanges() {
    if (this.mediaFiles) {
      this.filteredMediaFiles = this.mediaFiles; 
      this.selectedMediaFilter = 'all';
    }
  }

  onMediaFilterChange(filter: 'all' | 'images' | 'files') {
    this.selectedMediaFilter = filter;
    this.filterMediaFiles();
  }

  filterMediaFiles() {
    if (this.selectedMediaFilter === 'all') {
      this.filteredMediaFiles = this.mediaFiles;
    } else if (this.selectedMediaFilter === 'images') {
      this.filteredMediaFiles = this.mediaFiles.filter(
        file => file.type === 'IMAGE'
      );
    } else if (this.selectedMediaFilter === 'files') {
      this.filteredMediaFiles = this.mediaFiles.filter(
        file => file.type === 'FILE'
      );
    }
  }

  onPreviewImage(file: any, index: number) {
    this.previewImage.emit({ file, index });
  }

  onDownloadFile(file: any) {
    this.downloadFile.emit(file);
  }

  getFileIcon(mimeType: string): string {
    if (!mimeType) return 'insert_drive_file';
    
    if (mimeType.includes('pdf')) return 'picture_as_pdf';
    if (mimeType.includes('doc')) return 'description';
    if (mimeType.includes('csv') || mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'table_chart';
    if (mimeType.includes('text')) return 'text_snippet';
    
    return 'insert_drive_file';
  }

  getFileIconClass(mimeType: string): string {
    if (!mimeType) return 'file-default';
    
    if (mimeType.includes('pdf')) return 'file-pdf';
    if (mimeType.includes('doc')) return 'file-doc';
    if (mimeType.includes('csv') || mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'file-csv';
    if (mimeType.includes('text')) return 'file-text';
    
    return 'file-default';
  }
}
